export const enum OdsTypeEnum {
    Store = 0,
    Custom = 1,
    Emergency = 2
}